










































import { Component, Mixins, Prop } from 'vue-property-decorator'
import { Getter, namespace, State } from 'vuex-class'
import { hyphenatedCurrentLocale as locale } from 'bits/current_locale'
import AvatarImage from 'vuecomponents/avatar_image.vue'
import RelativeTime from 'library/v4/components/relative-time.vue'
import { anonymous, blankUser } from 'bits/user_model'
import { Id } from 'types'
import { Wish, Tenant, User } from '@padlet/arvo'
@Component({
  components: { AvatarImage, RelativeTime },
})
export default class SurfacePostAuthorNew extends Mixins() {
  @Prop() post!: Required<Wish>
  @Prop() user!: User
  @State tenant!: Tenant
  @Getter isStream!: boolean
  @Getter colorScheme!: 'light' | 'dark'
  @(namespace('userContributor').Getter) getUserById!: (id: Id) => Required<User>
  @(namespace('userContributor').Action) fetchUser!: (id: Id) => void
  get author(): Required<User> {
    return this.getUserById(this.post.author_id) || blankUser
  }
  get authorName(): string {
    return this.isRegistered ? this.author.name || this.author.username : anonymous
  }
  get authorProfileUrl(): string {
    return this.author.profile_url
  }
  get isRegistered(): boolean {
    return this.author.registered || !!this.author.registered_at
  }
  get updatedAt(): string | Date {
    return this.post.content_updated_at || this.post.created_at
  }
  get createdAtDateString(): string {
    const createdAtDate = new Date(this.post.created_at)
    const today = new Date()
    let options = {}
    if (today.toDateString() === createdAtDate.toDateString()) {
      options = {
        hour: 'numeric',
        minute: 'numeric',
        hour12: false,
      }
    } else {
      options = {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false,
      }
    }

    return new Intl.DateTimeFormat(locale, options).format(createdAtDate)
  }
  mounted(): void {
    this.fetchUser(this.post.author_id)
  }
}
